import * as Yup from 'yup';
import { t } from 'src/lib/language';

const NotificationContactValidator = (lang: string) => Yup.object().shape({
  email: Yup.string()
    .transform((value) => (!!value ? value : null))
    .nullable()
    .email(t(lang, 'validations.notifications.invalid_email')),
  phone: Yup.string()
    .transform((value) => (!!value ? value : null))
    .nullable()
    .matches(/^\d+$/, t(lang, 'validations.notifications.invalid_phone')),
})
  .test(
    'contact-required',
    t(lang, 'validations.notifications.at_least_one_contact_required'),
    function checkContact(values) {
      const email = (values.email || '').trim();
      const phone = (values.phone || '').trim();

      if (!email && !phone) {
        return this.createError({
          path: 'email',
          message: t(lang, 'validations.notifications.at_least_one_contact_required'),
        });
      }
      return true;
    },
  );

export default NotificationContactValidator;
